// extracted by mini-css-extract-plugin
export default {"modal":"StartOver_modal__NFUAq","actions":"StartOver_actions__oc38N","button":"StartOver_button__lvNCT","text":"StartOver_text__HTCus"};